module.exports = __webpack_public_path__ + "static/media/mc_eject_tube.faf11167.svg";